import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogActions, Button, Slide } from '@mui/material';
import { styled } from '@mui/system';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialogIcon = styled('div')(({ theme, alerttype }) => {
  const alertColors = {
    error: theme.palette.error.main,
    warning: theme.palette.warning.dark,
    success: theme.palette.success.main,
  };

  return {
    backgroundColor: alertColors[alerttype] || alertColors.success,
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    '& .MuiSvgIcon-root': {
      fontSize: '8rem', // Adjust the icon size
    },
  };
});

const StyledDialogActions = styled(DialogActions)({
  justifyContent: 'center',
  padding: '16px',
});

const alertConfig = {
  error: {
    icon: <ErrorOutlineIcon />,
    title: "Error",
  },
  warning: {
    icon: <WarningAmberIcon />,
    title: "Warning",
  },
  success: {
    icon: <CheckCircleIcon />,
    title: "Success",
  },
};

const AlertModal = ({ open, onClose, alertType = 'success', message }) => {
    const alert = alertConfig[alertType] || alertConfig.success;
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={onClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <StyledDialogIcon alerttype={alertType}>
                {alert.icon}
                <div>{alert.title}</div>
            </StyledDialogIcon>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {typeof message === 'string' ? message : JSON.stringify(message, null, 2)}
                </DialogContentText>
            </DialogContent>
            <StyledDialogActions>
                <Button onClick={onClose} color="primary">
                    Cerrar
                </Button>
            </StyledDialogActions>
        </Dialog>
    );
};

export default AlertModal;
